import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getToolbarStyles = (theme: Theme) =>
    css({
        display: 'flex',
        padding: theme.spacing(),
    });

export const getToolbarItemStyles = (isActive?: boolean) => (theme: Theme) =>
    css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 0,
        borderRadius: theme.borderRadius.S,
        backgroundColor: theme.palette.white,
        padding: theme.spacing(0.5),
        cursor: 'pointer',

        ...(isActive && {
            backgroundColor: theme.palette.secondary.light,
        }),

        ':hover': {
            backgroundColor: theme.palette.secondary.ultraLight,
        },

        ':disabled': {
            backgroundColor: theme.palette.white,
            cursor: 'not-allowed',
        },
    });

export function getToolbarGroupStyles(theme: Theme) {
    return css({
        display: 'flex',
        gap: theme.spacing(0.25),
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: theme.spacing(),
    });
}
